var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        {
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v(_vm._s(_vm.$t("backText"))),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [_vm._v(" " + _vm._s(_vm.$t("WarehouseManagement.form.Basic")) + " ")]
      ),
      _c("div", { staticClass: "bj-row mt20" }, [
        _c(
          "div",
          { staticClass: "bj-col-12", staticStyle: { "padding-left": "0" } },
          [
            _c("div", { staticClass: "bj-form-item" }, [
              _c("div", { staticClass: "bj-form-item-label" }, [
                _vm._v(
                  _vm._s(_vm.$t("BusinessPurchaseComponentsCom.invoiceNo"))
                ),
              ]),
              _c("div", { staticClass: "bj-form-item-value" }, [
                _vm._v(_vm._s(_vm.invoiceNumber)),
              ]),
            ]),
            _c("div", { staticClass: "bj-form-item" }, [
              _c("div", { staticClass: "bj-form-item-label" }, [
                _vm._v(_vm._s(_vm.$t("OrderPostage.time"))),
              ]),
              _c("div", { staticClass: "bj-form-item-value" }, [
                _vm._v(_vm._s(_vm.invoiceDate)),
              ]),
            ]),
            _c("div", { staticClass: "bj-form-item" }, [
              _c("div", { staticClass: "bj-form-item-label" }, [_vm._v("CSV")]),
              _c("div", { staticClass: "bj-form-item-value" }, [
                _vm.csvUrl
                  ? _c(
                      "a",
                      { attrs: { href: _vm.csvUrl } },
                      [
                        _c("el-button", { attrs: { type: "primary" } }, [
                          _vm._v(_vm._s(_vm.$t("billingPage.Download"))),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
          ]
        ),
        _c("div", { staticClass: "bj-col-12" }, [
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(_vm._s(_vm.$t("InternalOrderList.company"))),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(_vm._s(_vm.logisticsCompany)),
            ]),
          ]),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [
              _vm._v(_vm._s(_vm.$t("OrderPostage.create"))),
            ]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm._v(_vm._s(_vm.creationDate)),
            ]),
          ]),
          _c("div", { staticClass: "bj-form-item" }, [
            _c("div", { staticClass: "bj-form-item-label" }, [_vm._v("PDF")]),
            _c("div", { staticClass: "bj-form-item-value" }, [
              _vm.pdfUrl
                ? _c(
                    "a",
                    { attrs: { href: _vm.pdfUrl } },
                    [
                      _c("el-button", { attrs: { type: "primary" } }, [
                        _vm._v(_vm._s(_vm.$t("billingPage.Download"))),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
      [
        _c(
          "BjDivider",
          [
            _vm._v(_vm._s(_vm.$t("OrderPostage.yet")) + " "),
            _c(
              "template",
              { slot: "right" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.onmatchedExport()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("exportText")))]
                ),
              ],
              1
            ),
          ],
          2
        ),
        _c(
          "el-table",
          {
            attrs: {
              border: "",
              script: "",
              "max-height": "545px",
              data: _vm.data.goodsList2,
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                type: "index",
                width: "60",
                align: "center",
                label: _vm.$t("table.countText"),
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "consignmentNumber",
                label: _vm.$t("OrderPostage.logitisic"),
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "outerOrderNo",
                label: _vm.$t("OrderPostage.outer"),
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "matchType",
                label: _vm.$t("BjDialogListConfig.Types"),
                align: "center",
              },
            }),
            !_vm.$store.getters.cusId
              ? _c("el-table-column", {
                  attrs: {
                    prop: "cusId",
                    label: _vm.$t("billingPage.CustomerName"),
                    align: "center",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              " " +
                                _vm._s(_vm.customerList.bjGet(row.cusId)) +
                                " "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    4087168896
                  ),
                })
              : _vm._e(),
            _c("el-table-column", {
              attrs: {
                prop: "profitMargin",
                label: _vm.$t("BusinessPurchaseComponentsCom.Profit"),
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "recoveryStatus",
                label: _vm.$t("BusinessPurchaseComponentsCom.RecoveryStatus"),
                align: "center",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            row.recoveryStatus
                              ? _vm.$t(
                                  "BusinessPurchaseComponentsCom.Recovered"
                                )
                              : _vm.$t(
                                  "BusinessPurchaseComponentsCom.NotRecovered"
                                )
                          ) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                prop: "recoveredAmount",
                label: _vm.$t("BusinessPurchaseComponentsCom.amount"),
                align: "center",
              },
            }),
            _c(
              "el-table-column",
              {
                attrs: {
                  prop: "",
                  label: _vm.$t("OrderPostage.fee"),
                  align: "center",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "freightCharge",
                    label: _vm.$t("OrderPostage.Freight"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "freightChargeGst",
                    label: _vm.$t("OrderPostage.tax"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "fuelCharge",
                    label: _vm.$t("OrderPostage.cost"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "fuelChargeGst",
                    label: _vm.$t("OrderPostage.Fuel"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "totalInvoiceAmount",
                    label: _vm.$t("OrderPostage.after"),
                    align: "center",
                  },
                }),
                _vm.logisticsCompany == "HUNT"
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "preAdditionalTotalAmount",
                        label: _vm.$t("OrderPostage.ExtraTax"),
                        align: "center",
                      },
                    })
                  : _vm._e(),
                _vm.logisticsCompany == "DIFE"
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "preOverweightTotalAmount",
                        label: _vm.$t("OrderPostage.taxsurcharge"),
                        align: "center",
                      },
                    })
                  : _vm._e(),
                _vm.logisticsCompany == "DIFE"
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "preExtraLongTotalAmount",
                        label: _vm.$t("OrderPostage.taxextra"),
                        align: "center",
                      },
                    })
                  : _vm._e(),
                _vm.logisticsCompany == "DIFE"
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "preResendTotalAmount",
                        label: _vm.$t("OrderPostage.taxreturn"),
                        align: "center",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "el-table-column",
              {
                attrs: {
                  prop: "",
                  label: _vm.$t("OrderPostage.ERP"),
                  align: "center",
                },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "freightChargeErp",
                    label: _vm.$t("OrderPostage.Freight"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "fuelChargeErp",
                    label: _vm.$t("OrderPostage.cost"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "totalGstErp",
                    label: _vm.$t("OrderPostage.Totals"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "totalPriceErp",
                    label: _vm.$t("OrderPostage.amount"),
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "preTotalPriceErp",
                    label: _vm.$t("OrderPostage.after"),
                    align: "center",
                  },
                }),
              ],
              1
            ),
            _c("el-table-column", {
              attrs: {
                prop: "percentage",
                label: _vm.$t("OrderPostage.lose"),
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                prop: "difference",
                label: _vm.$t("OrderPostage.over"),
                align: "center",
              },
            }),
            _vm.logisticsCompany == "ALLI"
              ? _c("el-table-column", {
                  attrs: {
                    prop: "invoiceNotes",
                    label: _vm.$t("OrderPostage.invoiceNotes"),
                    align: "center",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }